import React, { FC, useContext, useMemo } from 'react';

import BasicButton from '../../../components/buttons/basicButton';
// components
import AampeTooltip from '../../../components/shared/AampeTooltip/AampeTooltip';

// contexts
import { EditorContext } from '../../../context/EditorContext';

// hooks
import useFormulaReview from '../../../hooks/formulas/useFormulaReview';
import useRoleFlags from 'hooks/auth/useRoleFlags';

interface FormulaReviewActionProps {
    formulaId: string;
}

const FormulaReviewAction: FC<
    React.PropsWithChildren<FormulaReviewActionProps>
> = ({ formulaId }) => {
    const { hasWriteAccess } = useRoleFlags();
    const reviewFormula = useFormulaReview(formulaId);

    const {
        editorDetails: { previews, isControlledFormula, formula },
    } = useContext(EditorContext);
    const handleReview = () => {
        if (formulaId) {
            reviewFormula.mutate(formulaId);
        }
    };

    const disableAndToolTipMessage = useMemo<
        | {
              isNotValidated: boolean;
              buttonTooltipText: string;
          }
        | undefined
    >(() => {
        if (!formula?.reward_function_id) {
            return {
                isNotValidated: true,
                buttonTooltipText: 'Select a reward function to continue.',
            };
        }
    }, [formula]);

    return (
        <>
            {!isControlledFormula && (
                <AampeTooltip
                    title={
                        disableAndToolTipMessage?.buttonTooltipText ||
                        'Mark this message as needing review (you will find it listed in the “review” tab of the draft catalog).'
                    }
                    arrow
                >
                    <span>
                        <BasicButton
                            name="Request for review"
                            isPrimary={false}
                            isLoading={reviewFormula.isPending}
                            isDisabled={
                                !previews?.length ||
                                reviewFormula.isPending ||
                                !hasWriteAccess ||
                                disableAndToolTipMessage?.isNotValidated
                            }
                            action={handleReview}
                        />
                    </span>
                </AampeTooltip>
            )}
        </>
    );
};

export default FormulaReviewAction;
